module.exports = __webpack_public_path__ + "img/mysql.3853b711.png";